/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdatePositionNormDto
 */
export interface CreateUpdatePositionNormDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePositionNormDto
     */
    normId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePositionNormDto
     */
    taskNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdatePositionNormDto
     */
    mode?: CreateUpdatePositionNormDtoModeEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdatePositionNormDto
     */
    resultTrue?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdatePositionNormDto
     */
    resultRawFrom?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdatePositionNormDto
     */
    resultRawTo?: number | null;
}


/**
 * @export
 */
export const CreateUpdatePositionNormDtoModeEnum = {
    centyl: 'centyl',
    ten: 'ten',
    sten: 'sten',
    stanin: 'stanin',
    przeliczony: 'przeliczony'
} as const;
export type CreateUpdatePositionNormDtoModeEnum = typeof CreateUpdatePositionNormDtoModeEnum[keyof typeof CreateUpdatePositionNormDtoModeEnum];


/**
 * Check if a given object implements the CreateUpdatePositionNormDto interface.
 */
export function instanceOfCreateUpdatePositionNormDto(value: object): value is CreateUpdatePositionNormDto {
    return true;
}

export function CreateUpdatePositionNormDtoFromJSON(json: any): CreateUpdatePositionNormDto {
    return CreateUpdatePositionNormDtoFromJSONTyped(json, false);
}

export function CreateUpdatePositionNormDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdatePositionNormDto {
    if (json == null) {
        return json;
    }
    return {
        
        'normId': json['normId'] == null ? undefined : json['normId'],
        'taskNumber': json['taskNumber'] == null ? undefined : json['taskNumber'],
        'mode': json['mode'] == null ? undefined : json['mode'],
        'resultTrue': json['resultTrue'] == null ? undefined : json['resultTrue'],
        'resultRawFrom': json['resultRawFrom'] == null ? undefined : json['resultRawFrom'],
        'resultRawTo': json['resultRawTo'] == null ? undefined : json['resultRawTo'],
    };
}

export function CreateUpdatePositionNormDtoToJSON(value?: CreateUpdatePositionNormDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'normId': value['normId'],
        'taskNumber': value['taskNumber'],
        'mode': value['mode'],
        'resultTrue': value['resultTrue'],
        'resultRawFrom': value['resultRawFrom'],
        'resultRawTo': value['resultRawTo'],
    };
}

